import { useState, useEffect } from "react";

import { KeyboardUtils } from "../helpers/keyboard_utils";

export const useCalendar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isVisible) return;

    const cleanup = KeyboardUtils.setupEscapeHandler(() => setIsVisible(false));
    KeyboardUtils.toggleBodyScroll(true);

    return () => {
      cleanup();
      KeyboardUtils.toggleBodyScroll(false);
    };
  }, [isVisible]);

  const show = () => setIsVisible(true);
  const hide = () => setIsVisible(false);

  const handleOverlayClick = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      hide();
    }
  };

  return {
    isVisible,
    show,
    hide,
    handleOverlayClick,
  };
};
